module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_base-e6b26f60644ef021efa6c399a5e7e71d.svg";